// extracted by mini-css-extract-plugin
module.exports = {"jobList":"multiple_processes_modal-module_jobList_4d5fe"};